export const CHANNEL_CARD_VIEW = 'w:ChannelCard:view';
export const CHANNEL_CLICK = 'w:Channel:click';
export const CHANNEL_FOLLOW = 'w:Channel:follow';
export const CHANNEL_UNFOLLOW = 'w:Channel:unfollow';
